module.exports = __webpack_public_path__ + "media/images/category/feature/profile/profile-kinoko-b1d759e94b52dc41277ad0475292f1ce.jpg";